// The script provides smooth scrolling.
// It supports accessibility in a way that if you click a link, the focus will be changed on the element matching ID of the link.

// Source:
// https://css-tricks.com/smooth-scrolling-accessibility/



const _debounce = require('lodash.debounce');


///////////////////////////////////////////////StickyMenuManager/////////////////////////////////////////////

function StickyMenuManager($stickyElement, menuClass) {
    this.$stickyElement = $stickyElement;
    this.$clonedStickyElement = this.$stickyElement.clone().addClass("cloned-sticky-element").insertAfter(this.$stickyElement).css('visibility', 'hidden');
    this.$originalMenu = this.$stickyElement.find(menuClass);
    this.$clonedMenu = this.$clonedStickyElement.find(menuClass);
    this.lastOriginalScrollLeft = 0;
    this.lastClonedScrollLeft = 0;
    this.fixed = false;

    this.listenForPageScroll();
}

StickyMenuManager.prototype.listenForPageScroll = function() {
    const _this = this;

    function handleScroll() {
        const scrollTop = $(window).scrollTop();
        const whereToFix = _this.$stickyElement.offset().top;

        if (scrollTop > whereToFix) {
            if (!_this.fixed) {
                _this.setStickyNav();
                _this.fixed = true;
            }
        } else if (_this.fixed) {
            _this.unsetStickyNav();
            _this.fixed = false;
        }
    }

    $(window).scroll(_debounce(function() {
        handleScroll();
    }, 10));
    handleScroll();
};

/* This function sets the sticky menu visible and hides the original menu */
/* I used visibility attribute (instead of display) to show/hide cloned sticky navigation, because, only in this case scrollLeft works */
StickyMenuManager.prototype.setStickyNav = function() {
    const currentScrollLeft = this.$originalMenu.scrollLeft();
    if (currentScrollLeft !== this.lastOriginalScrollLeft) {
        this.$clonedMenu.scrollLeft(currentScrollLeft);
        this.lastOriginalScrollLeft = currentScrollLeft;
    }
    this.$stickyElement.css('visibility', 'hidden');
    this.$clonedStickyElement.css('visibility', 'visible');
};

/* This function hides the sticky menu and make the original menu visible again */
/* I used visibility attribute (instead of display) to show/hide cloned sticky navigation, because, only in this case scrollLeft works */
StickyMenuManager.prototype.unsetStickyNav = function() {
    const currentScrollLeft = this.$clonedMenu.scrollLeft();
    if (currentScrollLeft !== this.lastClonedScrollLeft) {
        this.$originalMenu.scrollLeft(currentScrollLeft);
        this.lastClonedScrollLeft = currentScrollLeft;
    }
    this.$stickyElement.css('visibility', 'visible');
    this.$clonedStickyElement.css('visibility', 'hidden');
};

StickyMenuManager.prototype.getCloneHeight = function() {
    return this.$clonedStickyElement.height();
};


//////////////////////////////////////////////////ContextMenuManager/////////////////////////////////////////////////////////////

function ContextMenuManager ($menus, $links, $sections, stickyElementHeight) {
    this.stickyElementHeight = stickyElementHeight;
    this.$menus = $menus;
    this.$allLinks = $links;
    this.$sections = $sections;
    this.currentSection = '';

    this.listenForSectionScroll();
    this.listenForLinkClick();
}

/* This function listens for a user's scroll of a page in the browser */
/* and updates the menu according to the current section, that he is scrolling through */
ContextMenuManager.prototype.listenForSectionScroll = function() {
    const _this = this;

    function handleScroll () {
        const cur_pos = $(window).scrollTop();
        const bottomOfThePage = $(document).height() - $(window).height();

        _this.$sections.each(function(index) {
            const top = $(this).offset().top - _this.stickyElementHeight;
            const bottom = top + $(this).outerHeight();

            if ((cur_pos >= top && cur_pos <= bottom) ||  (index===_this.$sections.length-1 && cur_pos === bottomOfThePage)) {
                const newHash =  '#' + $(this).attr('id');
                if (_this.currentSection !== newHash) {
                    _this.setSection(newHash);
                    _this.updateActiveMenuItem();
                }
                _this.updateMenuScrollbarHorizontalPosition();
            }
        });
    }

    $(window).scroll(_debounce(function () {
        handleScroll();
    }, 10));
};

/* This function listens for a section change that a user does in the menu */
ContextMenuManager.prototype.listenForLinkClick = function () {
    const _this = this;
    this.$allLinks.click(function (e) {
        e.preventDefault();
        _this.setSection(this.hash);
        _this.updateActiveMenuItem();
        _this.updatePageScrollVericalPosition();
        _this.updateMenuScrollbarHorizontalPosition();
    });
};

ContextMenuManager.prototype.setSection = function (hash) {
    this.currentSection = hash;
};

/* This function updates scrollLeft position of the horizontal menu according to current section */
ContextMenuManager.prototype.updateMenuScrollbarHorizontalPosition = function () {
    const _this = this;

    this.$menus.each(function () {
        const $menu = $(this);
        let $target = null;
        const visibleArea = $menu.outerWidth();
        _this.$allLinks.each(function () {
            if (this.hash === _this.currentSection) {
                $target = $(this);
            }
        });
        let currentSectionPosition = $target.position().left;
        currentSectionPosition += ($target.outerWidth() / 2) - (visibleArea / 2);
        $menu.scrollLeft(currentSectionPosition);
    });
};

/* This function updates the active element in the menu according to current section */
ContextMenuManager.prototype.updateActiveMenuItem = function() {
    const _this = this;
    this.$allLinks.removeClass('active');
    this.$allLinks.each(function() {
        if (this.hash === _this.currentSection) {
            $(this).addClass('active');
        }
    });
};

/* This function scrolls the page to the current section */
ContextMenuManager.prototype.updatePageScrollVericalPosition = function () {
    const $target = $(this.currentSection);
    const $heading = $target.find('h2').first();
    const newPosition = $target.offset().top - this.stickyElementHeight + 2; //+2 to aviod the situation where scroll position is balancing between two sections
    window.scroll({
        top: newPosition,
        left: 0,
        behavior: 'smooth'
    });

    _debounce(function () {
        if ($heading.is(":focus")) { // Checking if the target was focused
            return false;
        } else {
            $heading.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $heading.focus(); // Setting focus
        };
    }, 100);
};


/////////////////////////////////////////////////////////////////////////////////////


$(document).ready(function () {

    let stickyHeight = 0;
    const $elementToBeSticky = $('.js-sticky');
    if ($elementToBeSticky.length) {
        const stickyMenuManager = new StickyMenuManager($elementToBeSticky, '.js-context-menu');
        stickyHeight = stickyMenuManager.getCloneHeight();
    }

    /* Two menu instances */
    /* The original menu and its clone (from the above code) */
    const $menus = $('.js-context-menu');

    /* Links in context menu */
    /* It's a sum of links from the original menu and its clone (fixed menu) */
    const $links = $menus.find('a[href*="#"]');

    /* Sections on a product page, like: Product Information, Specification, Related products */
    const $sections = $('.js-context-menu-sections').find('section');

    /* Creating a ContextMenuManager */
    if ($links.length && $sections.length) {
        new ContextMenuManager($menus, $links, $sections, stickyHeight);
    }

});